import { withLazy } from 'app/hocs/withLazy'

export const Faq = withLazy(() => import('features/Faq/pages/Faq'))
